(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  function boot() {
    document.querySelectorAll('#lintel-selector').forEach(init);
  }

  function init(root) {
    if (!root || root.__lsBound) return;
    root.__lsBound = true;

    if (window.__selectedLintelType) {
    refresh();
    }
    document.addEventListener('lintel:type:selected', () => {
    refresh();
    });



    // ----- elements -----
    const $wall   = root.querySelector('#ls-wall');
    const $count  = root.querySelector('#ls-count');
    const $grid   = root.querySelector('#ls-grid');
    const $therm  = root.querySelector('#ls-thermally-broken');
    const $wide   = root.querySelector('#ls-wide-inner-leaf');
    const $brand = root.querySelector('#ls-brand');
    const $dutyLabels = root.querySelector('#ls-duty-labels');

    const LINTEL_TYPE_BY_BRAND = {
    concrete: ['naylor'],
    steel: ['catnic', 'birtley', 'stressline']
    };

    let selectedLintelType = window.__selectedLintelType || null;



    // Cavity width UI
    const $cavityWrap = root.querySelector('#ls-cavity-wrap');
    const $cavitySel  = root.querySelector('#ls-cavity'); // keep as-is per current markup

    // Duty slider UI
    const $duty    = root.querySelector('#ls-duty');
    const $dutyCur = root.querySelector('#ls-duty-current');

    // Update Duty Labels for lintel type
    function updateDutyLabels() {
      const labels = root.querySelectorAll('#ls-duty-labels span');
      if (!labels.length) return;

      const isConcrete = selectedLintelType === 'concrete';

      labels.forEach(label => {
        const idx = Number(label.dataset.duty);

        if (isConcrete) {
          // Only show Standard (1) and Heavy (3)
          label.style.display = (idx === 1 || idx === 3) ? '' : 'none';
        } else {
          // Steel = show everything
          label.style.display = '';
        }
      });
    }

    function renderDutyLabels() {
      const el = root.querySelector('#ls-duty-labels');
      if (!el) return;

      if (selectedLintelType === 'concrete') {
        el.classList.add('is-2');
        el.innerHTML = `<span>Standard</span><span>Heavy</span>`;
      } else {
        el.classList.remove('is-2');
        el.innerHTML = `
          <span>All</span>
          <span>Standard</span>
          <span>Medium</span>
          <span>Heavy</span>
          <span>Extra Heavy</span>
        `;
      }
    }



    // optional intro text under the title
    const $intro = document.querySelector('#ls-intro');

    // ----- state -----
    const state = {
      wall: '',
      brand: '',
      thermally_broken: false,
      wide_inner_leaf: false,
      cavity_width: '',        // "70-85mm" etc.
      dutyThreshold: 0         // 0=All, 1=Standard, 2=Medium, 3=Heavy, 4=Extra Heavy
    };

    let ALL = null;

   



    // wall → product_type (or metafield lintel_type) mapping
    const typeMap = {
      cavity:       ['Cavity Lintels'],
      single_leaf:  ['Single Leaf Wall Lintels', '100mm Wide Box Lintels'],
      solid:        ['215mm Solid Wall Lintels', 'Concrete Lintels'],
      eaves:        ['100mm Wide Box Lintels'],
      timber_frame: ['Timber Frame Lintels']
    };

    function getDutyStops() {
      if (selectedLintelType === 'concrete') {
        return ['','Standard','','Heavy',''];
      }
      return ['All','Standard','Medium','Heavy','Extra Heavy'];
    }



    const normalise = s => (s == null ? '' : String(s).trim().toLowerCase());

    function toTitleCase(str) {
      return str.replace(/\w\S*/g, txt =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      );
    }

    function updateSelectorTitle() {
      const title = root.querySelector('#ls-selector-title');
      if (!title) return;

      if (selectedLintelType === 'concrete') {
        title.textContent = 'Concrete Lintel Selector';
      } else if (selectedLintelType === 'steel') {
        title.textContent = 'Steel Lintel Selector';
      } else {
        title.textContent = 'Lintel Product Selector';
      }
    }
    function updateModeUI() {
      const isConcrete = selectedLintelType === 'concrete';
      const isSteel = selectedLintelType === 'steel';

      // Hide steel-only controls for concrete
      if ($wall)        $wall.closest('.ls-field').style.display = isConcrete ? 'none' : '';
      if ($cavityWrap)  $cavityWrap.style.display = isConcrete ? 'none' : '';
      if ($brand)       $brand.closest('.ls-field').style.display = isConcrete ? 'none' : '';
      if ($therm)       $therm.closest('.ls-field').style.display = isConcrete ? 'none' : '';
      if ($wide)        $wide.closest('.ls-field').style.display = isConcrete ? 'none' : '';

      // Duty slider behaviour
      if (isConcrete) {
        $duty.min = 0;
        $duty.max = 1;
        $duty.step = 1;

        if (state.dutyThreshold !== 0 && state.dutyThreshold !== 1) {
          state.dutyThreshold = 0; // default Standard
        }
      } else {
        $duty.min = 0;
        $duty.max = 4;
        $duty.step = 1;
      }


      updateDutyUI();
    }
    function resetStateForMode() {
      if (selectedLintelType === 'concrete') {
        state.wall = '';
        state.brand = '';
        state.thermally_broken = false;
        state.wide_inner_leaf = false;
        state.cavity_width = '';
      }
    }



    // ---------------- Load all lintel products ----------------
    async function fetchAll() {
      if (ALL) return ALL;

      async function get(page) {
        try {
          const r = await fetch(`/collections/lintels?view=selector-json&page=${page}`);
          return await r.json();
        } catch (e) {
          console.error('Selector JSON error (page ' + page + '):', e);
          return {};
        }
      }

      const first = await get(1);
      let items = first.products || [];
      const seen = new Set(items.map(p => p.id));
      const pages = Number(first.pages || 1);

      if (pages > 1) {
        const rest = await Promise.all(
          Array.from({ length: pages - 1 }, (_, i) => get(i + 2))
        );
        rest.forEach(j => {
          (j.products || []).forEach(p => {
            if (!seen.has(p.id)) { seen.add(p.id); items.push(p); }
          });
        });
      } else {
        // conservative fallback (stop on repeat)
        for (let p = 2; p <= 50; p++) {
          const j = await get(p);
          const batch = j.products || [];
          if (!batch.length) break;
          const firstId = batch[0]?.id;
          if (firstId && seen.has(firstId)) break;
          batch.forEach(prod => {
            if (!seen.has(prod.id)) { seen.add(prod.id); items.push(prod); }
          });
        }
      }

      ALL = items;
      return items;
    }

    // ---------------- Badge helpers ----------------
    function hasYes(v) {
      const s = (v ?? '').toString().trim().toLowerCase();
      return s === 'yes' || s === 'true' || s === '1';
    }

    /**
     * Build up to two badges for a product.
     * Uses metafields + tags (fallback) and the existing dutyRank() for Heavy/Extra Heavy.
     */
    function getBadges(p) {
      const mf = p.metafields?.custom || {};
      const badges = [];

      // Thermally broken
      if (hasYes(mf.thermally_broken)) {
        badges.push({ key: 'thermally-broken', label: 'Thermally Broken' });
      }

      // Duty level — only Heavy/Extra Heavy
      const rank = dutyRank(p);
      if (rank >= 4) {
        badges.push({ key: 'extra-heavy-duty', label: 'Extra Heavy Duty' });
      } else if (rank >= 3) {
        badges.push({ key: 'heavy-duty', label: 'Heavy Duty' });
      }

      // Wide inner leaf
      if (hasYes(mf.wide_inner_leaf)) {
        badges.push({ key: 'wide-inner-leaf', label: 'Wide Inner Leaf' });
      }

      // Express delivery (metafield or tag fallback)
      const expressMeta = mf.express_delivery;
      const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
      const tagsStr = tags.join(' ').toLowerCase();
      if (hasYes(expressMeta) || tagsStr.includes('express-delivery') || tagsStr.includes('express delivery')) {
        badges.push({ key: 'express-delivery', label: 'Express Delivery' });
      }

      return badges.slice(0, 2);
    }

    // ---------------- Rendering ----------------
    function render(list) {
      if ($count) $count.textContent = list.length || 0;
      if (!$grid) return;

      if (!list.length) {
        $grid.innerHTML = `<p>No matches. Adjust your selection.</p>`;
        return;
      }

      const html = list.map(p => {
        const priceRaw = p.price ?? p.price_min ?? '';
        const price = Number(priceRaw / 100 || priceRaw);
        const img = (p.featured_image && p.featured_image.src) || p.image || '';
        const url = p.url || (p.handle ? `/products/${p.handle}` : '#');
        const title = p.title || 'Lintel';

        // badges (theme-native structure)
        const badges = getBadges(p);
        const badgesHTML = badges.length
          ? `<span class="badges" aria-label="${badges.map(b => b.label).join(', ')}">` +
              badges.map(b => `<div class="badge" data-badge="${b.key}">${b.label}</div>`).join('') +
            `</span>`
          : '';

        return `
          <article class="ls-card">
            ${badgesHTML}
            <a class="ls-img" href="${url}" aria-label="${title}">
              ${img ? `<img loading="lazy" src="${img}" alt="${title}">` : ''}
            </a>
            <h3 class="ls-title">${title}</h3>
            ${Number.isFinite(price)
              ? `<div class="ls-price">£${price.toFixed(2)} <small>inc VAT</small></div>`
              : ``}
            <a class="ls-link" href="${url}">View product</a>
          </article>
        `;
      }).join('');

      $grid.innerHTML = html;
    }

    // ---------------- Filters ----------------
    function filterByWall(products) {
      if (!state.wall) return products;
      const wanted = (typeMap[state.wall] || []).map(normalise);
      if (!wanted.length) return [];
      return products.filter(p => {
        const primary  = normalise(p.product_type);
        const fallback = normalise(p.metafields?.custom?.lintel_type);
        return wanted.includes(primary) || (fallback && wanted.includes(fallback));
      });
    }

    function filterCavityWidth(products) {
      if (!state.cavity_width) return products;
      const want = normalise(state.cavity_width); // e.g., "70-85mm"
      return products.filter(p => normalise(p.metafields?.custom?.cavity_width) === want);
    }

    function filterThermal(products) {
      if (!state.thermally_broken) return products;
      return products.filter(p => {
        const val = normalise(p.metafields?.custom?.thermally_broken);
        return val === 'yes' || val === 'true' || val === '1';
      });
    }

    function filterWide(products) {
      if (!state.wide_inner_leaf) return products;
      return products.filter(p => {
        const val = normalise(p.metafields?.custom?.wide_inner_leaf);
        return val === 'yes' || val === 'true' || val === '1';
      });
    }
    function filterBrand(products) {
      if (!state.brand) return products;
      return products.filter(p => normalise(p.vendor) === state.brand);
    }



    function filterByLintelType(products) {
      if (!selectedLintelType) return products;

      return products.filter(p => {
        const vendor = normalise(p.vendor);
        return LINTEL_TYPE_BY_BRAND[selectedLintelType].includes(vendor);
      });
    }


    // --- Duty ranking / fallback inference for Naylor concrete lintels ---
    function dutyRank(product) {
      // 1) explicit metafield wins
      const raw = normalise(product.metafields?.custom?.lintel_duty);
      if (raw) {
        if (raw.includes('extra')) return 4;
        if (raw.includes('heavy')) return 3;
        if (raw.includes('medium')) return 2;
        if (raw.includes('standard') || raw.includes('std')) return 1;
      }

      // 2) fallback for Naylor concrete lintels when metafield missing
      // detect "Naylor" and Economy/Hi Spec patterns in title or handle
      const title = normalise(product.title);
      const handle = normalise(product.handle);
      const isNaylor = title.includes('naylor') || handle.includes('naylor');

      if (isNaylor) {
        const isHiSpec = /hi[\s-]?spec/.test(title) || /hi[\s-]?spec/.test(handle);
        // Default economy if not Hi Spec
        return isHiSpec ? 3 : 1; // Hi Spec → Heavy(3), Economy → Standard(1)
      }

      // Unknown duty when slider threshold is set -> treat as 0 (won't pass filter)
      return 0;
    }

      function filterDuty(products) {
        const selected = Number(state.dutyThreshold ?? 0);

        // Concrete: only Standard(1) or Heavy(3)
        if (selectedLintelType === 'concrete') {
          const wantRank = selected === 1 ? 3 : 1; // 0->Standard, 1->Heavy
          return products.filter(p => dutyRank(p) === wantRank);
        }

        // Steel (existing behaviour)
        if (selected === 0) return products; // All
        return products.filter(p => dutyRank(p) === selected);
      }



    function applyFilters(products) {
      let list = products;
      list = filterByLintelType(list); 
      list = filterByWall(list);
      list = filterCavityWidth(list);
      list = filterThermal(list);
      list = filterWide(list);
      list = filterDuty(list);
      list = filterBrand(list);
      return list;
    }

    // Populate Brand Dropdown

    function populateBrandDropdown(allProducts) {
      if (!$brand) return;

      const allowed = selectedLintelType
        ? LINTEL_TYPE_BY_BRAND[selectedLintelType]
        : null;

      const vendors = Array.from(
        new Set(
          allProducts
            .map(p => normalise(p.vendor))
            .filter(v => v && (!allowed || allowed.includes(v)))
        )
      );

      $brand.innerHTML =
        `<option value="">All brands…</option>` +
        vendors
          .sort()
          .map(v => `<option value="${v}">${toTitleCase(v)}</option>`)
          .join('');
    }



    // ---------------- UI updates ----------------
    function updateCavityUI() {
      const isCavity = state.wall === 'cavity';
      if ($cavityWrap) $cavityWrap.style.display = isCavity ? '' : 'none';
      if (!isCavity && $cavitySel) {
        $cavitySel.value = '';
        state.cavity_width = '';
      }
    }

    function updateIntro() {
      if ($intro) $intro.style.display = state.wall ? 'none' : 'block';
    }

    function updateDutyUI() {
      if (!$duty || !$dutyCur) return;
      const stops = getDutyStops();
      const idx = Number(state.dutyThreshold || 0);
      $dutyCur.textContent = stops[idx] || '';
    }


    // ---------------- Refresh ----------------
    async function refresh() {
      selectedLintelType = window.__selectedLintelType || null;

      resetStateForMode();        // if you have this
      updateSelectorTitle();

      updateModeUI();             // 1️⃣ establish mode + slider bounds FIRST
      renderDutyLabels();         // 2️⃣ render the correct labels for that mode
      updateDutyUI();             // 3️⃣ sync “Showing: …” text

      updateCavityUI();
      updateIntro();

      const all = await fetchAll();
      populateBrandDropdown(all);
      
      const filtered = applyFilters(all);
      render(filtered);
    }



    // ---------------- Events ----------------
    if ($wall) {
      $wall.addEventListener('change', e => {
        state.wall = e.target.value || '';
        refresh();
      });
    }

    if ($cavitySel) {
      $cavitySel.addEventListener('change', e => {
        state.cavity_width = e.target.value || '';
        refresh();
      });
    }

    if ($therm) {
      $therm.addEventListener('change', e => {
        state.thermally_broken = e.target.checked;
        refresh();
      });
    }

    if ($wide) {
      $wide.addEventListener('change', e => {
        state.wide_inner_leaf = e.target.checked;
        refresh();
      });
    }

    if ($brand) {
      $brand.addEventListener('change', e => {
        state.brand = normalise(e.target.value || '');
        refresh();
      });
    }

    if ($duty) {
      $duty.addEventListener('input', e => {
        state.dutyThreshold = Number(e.target.value || 0);
        updateDutyUI();
      });
      $duty.addEventListener('change', () => {
        refresh();
      });
    }

    // ---------------- Initial Load ----------------
    (async () => {
      updateCavityUI();
      updateIntro();
      updateDutyUI();
      const all = await fetchAll();





  if (window.__selectedLintelType) {
  updateSelectorTitle();
  render(applyFilters(all));
}

    })();
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  const step1 = document.getElementById('ls-step-1');
  const selector = document.getElementById('lintel-selector');
  const backBtn = document.getElementById('ls-back');

  if (!step1 || !selector) return;

  // Step 1 → show selector
  step1.querySelectorAll('[data-lintel-type]').forEach(btn => {
    btn.addEventListener('click', () => {
      window.__selectedLintelType = btn.dataset.lintelType;

      step1.style.display = 'none';
      selector.style.display = 'block';

      document.dispatchEvent(new CustomEvent('lintel:type:selected'));
    });
  });

  // Back → return to Step 1
  backBtn?.addEventListener('click', () => {
    window.__selectedLintelType = null;

    selector.style.display = 'none';
    step1.style.display = 'block';
  });
});




